interface SectionHeadingProps {
  id: string;
  kicker: string;
  title: string;
  desc?: string;
  actionHref?: string;
  actionLabel?: string;
}

export default function SectionHeading({
  id,
  kicker,
  title,
  desc,
  actionHref,
  actionLabel,
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
      <div className="max-w-2xl">
        <span className="flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-primary-600">
          <span className="w-6 h-px bg-primary-400"></span>
          {kicker}
        </span>
        <h4 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
          <a href={`#${id}`} className="hover:text-primary-600 transition-colors cursor-pointer">
            {title}
          </a>
        </h4>
        {desc && <p className="mt-2 text-sm md:text-base text-foreground-600 leading-relaxed">{desc}</p>}
      </div>
      {actionHref && actionLabel && (
        <a
          href={actionHref}
          className="inline-flex items-center gap-1 self-start md:self-auto h-10 px-4 rounded-md border border-background-200 text-sm text-foreground-800 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          {actionLabel}
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </a>
      )}
    </div>
  );
}